<template>
            <video :src="src" @mouseenter="enter" @mouseleave="out" controls ></video>
</template>

<script>
export default {
    props:['src'],
    methods:{
        enter(e){
        e.target.play()
        },
        out(e){
        e.target.pause()
        },
    }
}
</script>

<style scoped lang="scss">
video{
    width: 100%;
    height: 150px;
}

    
</style>